import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from "@angular/router";
import { SharedHttp } from "../../../services/http-client.service";
import { LocationStrategy } from "@angular/common";
import { TranslateObjectPipe } from '../../../pipes/translate-object.pipe';
/**
 * Create Wallet Modal Component
 */
let CreateWalletModalComponent = class CreateWalletModalComponent {
    constructor(sanitizer, httpClient, router, location, themeService, translateObjectPipe) {
        this.sanitizer = sanitizer;
        this.httpClient = httpClient;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.translateObjectPipe = translateObjectPipe;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.walletPassword = '';
        this.confirmedWalletPassword = '';
        this.user = JSON.parse(localStorage.getItem('user'));
        this.createButtonDisabled = true;
        this.validName = false;
        this.validPassword = false;
        this.validConfirmPassword = false;
        this.passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,64}$/;
        this.createButtonClicked = false;
        this.showWalletPassword = false;
        this.showWalletPasswordAgain = false;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.walletName = this.translateObjectPipe.transform('WALLET.NAME_PLACEHOLDER');
    }
    close() {
        this.modal.destroy();
    }
    closeAndGoToHome() {
        this.modal.destroy();
        this.router.navigateByUrl('');
    }
    checkValidation() {
        this.walletName = this.walletName.trim();
        if (this.walletName.length >= 2 && this.walletName.length <= 14) {
            this.validName = true;
        }
        else {
            this.validName = false;
            this.createButtonDisabled = true;
            return;
        }
        if (this.passRegex.test(this.walletPassword)) {
            this.validPassword = true;
        }
        else {
            this.validPassword = false;
            this.createButtonDisabled = true;
            return;
        }
        if (this.walletPassword === this.confirmedWalletPassword) {
            this.validConfirmPassword = true;
        }
        else {
            this.validConfirmPassword = false;
            this.createButtonDisabled = true;
            return;
        }
        if (this.walletName !== '' && this.walletPassword !== '' && this.confirmedWalletPassword !== '') {
            this.createButtonDisabled = false;
        }
    }
    createWallet() {
        if (this.createButtonDisabled) {
            return;
        }
        this.createButtonClicked = true;
        const walletData = {
            defaultAccountName: this.walletName,
            passphrase: this.walletPassword,
            passphraseConfirmation: this.confirmedWalletPassword
        };
        this.httpClient.post('wallet/createaccount', walletData).subscribe((data) => {
            if (data === 'OK') {
                this.success();
                this.close();
            }
        });
    }
};
CreateWalletModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: SharedHttp },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: TranslateObjectPipe }
];
CreateWalletModalComponent = __decorate([
    Component({
        selector: 'ecd-create-wallet-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./create-wallet-modal.component.html")).default
    })
], CreateWalletModalComponent);
export { CreateWalletModalComponent };
